module.exports = "/images/app-store-logo_sm.svg?166ae94ef2c2d18cb8785f67cfefe8b6";